export const ABOUT = '/about';
export const APPLICANTS_CONFIRM = '/applicants/:id/confirm';
export const BUSINESS = 'https://business.otetsutabi.com';
export const BUSINESSES = '/businesses';
export const BUSINESSES_DETAIL = '/businesses/:id';
export const BUSINESS_SITES_DETAIL = '/business_sites/:id';
export const CANCEL_POLICY = '/cancellation-policy';
export const CONTACT = '/contact';
export const CORP = '/corp';
export const FAVORITE_PLANS = '/favorite-plans';
export const FOLLOWING_BUSINESSES = '/following/businesses';
export const HOME = '/';
export const LOGOUT = '/users/logout';
export const MCPR_TENRI = '/mcpr/tenri';
export const MCPR_USA = '/mcpr/usa';
export const MCPR_FUKUSHIMA = '/mcpr/fukushima';
export const MCPR_NISHIKAN = '/mcpr/nishikan';
export const MCPR_SHIZUOKA = '/mcpr/shizuoka';
export const MCPR_IMABARI = '/mcpr/imabari';
export const MCPR_BETSUKAI = '/mcpr/betsukai';
export const MCPR_ISHIKAWA = '/mcpr/ishikawa';
export const MCPR_TOBA = '/mcpr/toba';
export const MCPR_KOCHI = '/mcpr/kochi';
export const MCPR_OITA = '/mcpr/oita';
export const MCPR_TOHOKU = '/mcpr/tohoku';
export const PARTICIPANT_SCHEDULE = '/participants/:id/schedules';
export const PASSWORD_RESET_NEW = '/password_reset/new';
export const PASSWORD_RESET_NEW_COMPLETE = '/password_reset/new/complete';
export const PASSWORD_RESET_EDIT = '/password_reset/edit';
export const PASSWORD_RESET_EDIT_COMPLETE = '/password_reset/edit/complete';
export const PLAN = '/plans/:id';
export const PLANS = '/plans';
export const POLICY = '/policy';
export const PRIVACY_POLICY = '/privacy-policy';
export const PROVIDER_CONFIRM = '/users/provider/confirm';
export const PROVIDER_CONFIRM_COMPLETE = '/users/provider/confirm/complete';
export const REVIEW_PARTICIPANT = '/user/terms/:id/review';
export const ROOMS = '/rooms';
export const SIGN_UP = '/users/signup';
export const TERMS_OF_SERVICE = '/terms-of-service';
export const MYPAGE_PROFILE = '/mypage/profile';
export const MYPAGE_ACCOUNT = '/mypage/account';
export const USER_HISTORIES = '/user/histories';
export const USER_PAYMENT = '/user/payment';
export const USER_PAYMENT_HISTORY = '/user/payment/history';
export const USER_SCHEDULES = '/user/schedules';
export const USER_SKILLS = '/user/skills';
export const USER_WITHHOLDINGS = '/user/withholdings';
export const WITHDRAW = '/withdraw';
export const CONTACT_SHOW = '/contact';

export const LINE_AUTHORIZE = '/users/auth/line';
export const GOOGLE_AUTHORIZE = '/users/auth/google_oauth2';
export const FACEBOOK_AUTHORIZE = '/users/auth/facebook';
export const ONE_AUTHORIZE = '/users/auth/one';
export const NOT_FOUND = '/404';
export const UNPROCESSABLE_ENTITY = '/422';
export const INTERNAL_SERVER_ERROR = '/500';
export const MAINTENANCE = '/503';
export const OFFLINE = '/offline';
// External
export const NOTE = 'https://note.com/otetsutabi';
export const HOW_TO_JOIN = 'https://media.otetsutabi.com/20240509-2/';
export const EXPERIENCE =
  'https://media.otetsutabi.com/category/%e3%81%8a%e3%81%a6%e3%81%a4%e3%81%b3%e3%81%a8/';

export const APP_VIEW = '/app_view';

// 関数で作成しているが、可能であればコンポーネントを定義したい。
// 利用規約か会社概要ページをSPA対応した際に、実際に関数で作成するかコンポーネントで作成するかを決定する
export const determineAppViewPath = (pathname: string): string => {
  // Webからの遷移の場合、pathnameをそのまま返す
  if (!window.location.pathname.includes(APP_VIEW)) return pathname;

  // WebView表示の場合は、WebView表示用のpathを返す
  return `${APP_VIEW}${pathname}`;
};

// TODO ApiServiceクラスに移行する
export const API_V1_USERS_WITHDRAW = '/api/v1/users/withdraw';
export const API_V1_APPLICANTS_CANCEL = '/api/v1/applicants/:id/cancel';
